module.exports = __webpack_public_path__ + "img/10.8f6c3248.png";